<template>
  <div :id="`genai_${type}_category`">
    <div class="text-subtitle-2 pa-1 blue--text blue lighten-5">
      パラメータを調整しながら文章を生成できます。
    </div>
    <v-card tiletile elevation="0" class="item-card pa-2">
      <v-card-text class="pa-0">
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" :sm="mode === 'drawer' ? 12 : 4">
                <v-row>
                  <v-col cols="12">
                    <div class="font-bold mb-2">性格</div>
                    <v-select
                      v-model="selectedPersonality"
                      :items="[
                        ...selectItem.genaiShopCommentPersonality,
                        setting.text_input_label,
                      ]"
                      label="性格を選択"
                      outlined
                      success
                      hide-details
                      class="mb-2"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="selectedPersonality === setting.text_input_label"
                  >
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="性格（テキスト入力）"
                      :rules="
                        selectedPersonality === setting.text_input_label
                          ? 'required|max:20'
                          : ''
                      "
                    >
                      <v-text-field
                        :disabled="
                          selectedPersonality !== setting.text_input_label
                        "
                        v-model="textPersonality"
                        label="性格（テキスト入力）"
                        :error-messages="errors"
                        :success="valid"
                        persistent-hint
                        outlined
                        counter="20"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-divider class="mt-4 mb-6"></v-divider>
                <v-row>
                  <v-col cols="12">
                    <div class="font-bold mb-2">アピールポイント</div>
                    <v-select
                      v-model="selectedSpecialty"
                      :items="[
                        ...selectItem.genaiShopCommentSpecialty,
                        setting.text_input_label,
                      ]"
                      label="アピールポイントを選択"
                      outlined
                      success
                      hide-details
                      class="mb-2"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="selectedSpecialty === setting.text_input_label"
                  >
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="アピールポイント（テキスト入力）"
                      :rules="
                        selectedSpecialty === setting.text_input_label
                          ? 'required|max:20'
                          : ''
                      "
                    >
                      <v-text-field
                        :disabled="
                          selectedSpecialty !== setting.text_input_label
                        "
                        v-model="textSpecialty"
                        label="アピールポイント（テキスト入力）"
                        :error-messages="errors"
                        :success="valid"
                        persistent-hint
                        outlined
                        counter="20"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-divider class="mt-4 mb-6"></v-divider>
                <v-row>
                  <v-col cols="12">
                    <div class="font-bold mb-2">趣味</div>
                    <v-select
                      v-model="selectedHobbies"
                      :items="[
                        ...selectItem.genaiShopCommentHobbies,
                        setting.text_input_label,
                      ]"
                      label="趣味を選択"
                      outlined
                      success
                      hide-details
                      class="mb-2"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    v-if="selectedHobbies === setting.text_input_label"
                  >
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="趣味（テキスト入力）"
                      :rules="
                        selectedHobbies === setting.text_input_label
                          ? 'required|max:20'
                          : ''
                      "
                    >
                      <v-text-field
                        :disabled="selectedHobbies !== setting.text_input_label"
                        v-model="textHobbies"
                        label="趣味（テキスト入力）"
                        :error-messages="errors"
                        :success="valid"
                        persistent-hint
                        outlined
                        counter="20"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-divider class="mt-4 mb-6"></v-divider>
                <v-row>
                  <v-col cols="12">
                    <div class="font-bold">キーワード・AI指示</div>
                    <div class="mb-2 text-subtitle-2">
                      その他のキーワード、又は、AIに指示したい内容を入力。スペース、カンマ、改行等で区切り複数指定が可能です。
                    </div>
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="キーワード・AI指示"
                      :rules="'max:100'"
                    >
                      <v-textarea
                        v-model="keyword"
                        label="キーワード・AI指示"
                        :error-messages="errors"
                        :success="valid"
                        persistent-hint
                        outlined
                        counter="100"
                        rows="3"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-divider class="mt-4 mb-6"></v-divider>
                <v-row>
                  <v-col cols="12">
                    <v-btn
                      class="info font-weight-bold"
                      block
                      :disabled="
                        month_generate_count >= setting.genai_max_generate_month
                      "
                      @click="onGenai"
                      ><v-icon left>mdi-robot</v-icon>生成する</v-btn
                    >
                    <div class="text-right">
                      <span class="mini"
                        >( 今月の利用回数 {{ month_generate_count }} /
                        {{ setting.genai_max_generate_month }}回 )</span
                      >
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                :sm="mode === 'drawer' ? 12 : 8"
                :class="mode === 'drawer' ? 'mt-8' : 'pl-sm-4 mt-12 mt-sm-0'"
              >
                <div class="mb-2 d-flex">
                  <div class="font-bold">生成結果</div>
                  <v-spacer></v-spacer>
                  <div v-if="genaiResponse" class="">
                    生成日時:{{ genaiTimestamp }}
                  </div>
                </div>
                <v-textarea
                  v-model="genaiResponse"
                  rows="8"
                  readonly
                  hide-details
                  outlined
                  background-color="white"
                  auto-grow
                />
                <div
                  v-if="genaiResponse"
                  class="text-right grey--text text--darken-1 text-caption pr-2"
                >
                  {{ (genaiResponse || "").length }}文字
                </div>
                <div
                  v-else
                  class="text-right grey--text text--darken-1 text-caption pr-2"
                >
                  生成してください
                </div>
                <div class="d-flex flex-row flex-sm-row flex-column">
                  <v-btn
                    class="success font-weight-bold mr-sm-2 mb-2 mb-sm-0 pa-2"
                    style="flex: 1"
                    :disabled="!genaiResponse"
                    @click="copyToClipboard"
                    ><v-icon left>mdi-content-copy</v-icon
                    >{{
                      mode === "drawer"
                        ? "結果をコピーして閉じる"
                        : "クリップボードにコピー"
                    }}
                  </v-btn>
                </div>
                <div class="mt-4">
                  <div
                    v-if="copied"
                    class="green--text text--darken-2 font-weight-bold text-center"
                  >
                    コピーしました
                  </div>
                  <div v-else>&nbsp;</div>
                </div>
                <div class="mt-4">
                  <div class="font-bold">注意事項</div>
                  <ul class="mt-2">
                    <li>
                      差別、誹謗中傷、暴力的な表現、過度な性的描写、または公序良俗に反する内容が含まれていると判断した場合は生成を拒否することがあります。
                    </li>
                    <li>
                      設定項目「目標文字数」はあくまで目安です。少ない場合や大きく超過する等、結果にばらつきがあります。
                    </li>
                    <li>
                      AIが自動生成した文章は、内容の正確性や適切性については保証されません。必ずご自身でご確認（または必要に応じて校正）の上、ご利用ください。
                    </li>
                  </ul>
                </div>
                <div class="mt-4">
                  <div class="font-bold">生成のコツ</div>
                  <ul class="mt-2">
                    <li>
                      セラピストの編集画面でプロフィールをたくさん設定すると文章にバリエーションが出やすくなります。
                    </li>
                    <li>
                      狙った文章を作りたい場合、キーワードを絞って指定する方が効果的です。
                    </li>
                    <li>
                      お店全体で文章の統一性を出したい場合は、AI設定タブの「店舗全体の設定」を確認してください。
                    </li>
                  </ul>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </ValidationObserver>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import {
  set,
  reactive,
  ref,
  toRefs,
  defineComponent,
  watch,
  onMounted,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import selectItem from "@/common/selectItem";
import utilDate from "@/common/utilDate.js";
import retryRequest from "@/common/retryRequest";

export default defineComponent({
  props: ["type", "cast_id", "mode"],
  setup(props, ctx) {
    const CastsRepository = repositoryFactory.get("casts");
    const CastPropsRepository = repositoryFactory.get("castProps");
    const AiRepository = repositoryFactory.get("ai");
    const ShopGenaiCountRepository = repositoryFactory.get("shopGenaiCounts");

    const copied = ref(false);

    const state = reactive({
      selectedPersonality: "未選択",
      selectedSpecialty: "未選択",
      selectedHobbies: "未選択",
      textPersonality: "",
      textSpecialty: "",
      textHobbies: "",
      keyword: "",
      genaiResponse: null,
      genaiTimestamp: null,
      month_generate_count: 0,
    });

    const onGenai = async () => {
      // 入力チェック
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        return;
      }

      // パラメータを保存する
      const castProps = [
        {
          cast_id: props.cast_id,
          key: "cast__genai__personality",
          value:
            state.selectedPersonality === setting.text_input_label
              ? setting.text_input_label + "||" + state.textPersonality
              : state.selectedPersonality,
        },
        {
          cast_id: props.cast_id,
          key: "cast__genai__specialty",
          value:
            state.selectedSpecialty === setting.text_input_label
              ? setting.text_input_label + "||" + state.textSpecialty
              : state.selectedSpecialty,
        },
        {
          cast_id: props.cast_id,
          key: "cast__genai__hobbies",
          value:
            state.selectedHobbies === setting.text_input_label
              ? setting.text_input_label + "||" + state.textHobbies
              : state.selectedHobbies,
        },
        {
          cast_id: props.cast_id,
          key: `cast__genai__${props.type}_keyword`,
          value: state.keyword,
        },
      ];
      const params = {
        cast_prop: castProps,
      };
      store.dispatch("loadingIcon/showIcon"); // ローディング表示
      const response = await retryRequest(CastPropsRepository.save_all, params);
      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
      if (response.data && response.data.status) {
        // 保存完了 >> 生成実行
      } else {
        alert(
          "パラメータの保存に失敗した為、生成できませんでした。再度実行してください。"
        );
        return;
      }

      ctx.emit("set-stateless", true); // 生成中はドロワーを操作不可にする

      store.dispatch("loadingIcon/showGenIcon");

      let cast_info = {};
      if (props.mode == "drawer") {
        // ドロワーモードの場合、親コンポーネントからキャスト名、プロパティを取得(保存されてない情報があるかもしれないため)
        await new Promise((resolve) => {
          ctx.emit("get_all_cast_data", resolve);
        }).then((data) => {
          if (data) {
            cast_info["name"] = data.cast_name || null;
            const tmp_props = [];
            Object.keys(data.cast_props || {}).forEach((key) => {
              tmp_props.push({
                cast_id: props.cast_id,
                key: key,
                value: data.cast_props[key],
              });
            });
            cast_info["props"] = tmp_props.concat(castProps); // 配列形式でセット
          }
        });
      } else {
        // 通常モードの場合、キャスト情報は不要
        cast_info = null;
      }

      // 生成処理実行
      const aiParams = {
        comment_type: props.type,
        shop_id: store.getters["shops/currentShop"].id,
        cast_id: props.cast_id,
        cast_info: cast_info || null, // ドロワーモードの場合のみセット
      };
      const aiResponse = await retryRequest(
        AiRepository.genai,
        aiParams,
        false,
        1
      );
      if (aiResponse.data && aiResponse.data.status) {
        // 生成結果セット
        // console.log("生成結果:", aiResponse.data);
        state.genaiResponse = aiResponse.data.data.generated_comment;
        state.genaiTimestamp = utilDate.getDatetimeFormatLongDisplay(
          new Date()
        );
      } else {
        alert("生成AIの処理に失敗しました。" + aiResponse.data.message);
      }
      getGenaiCount(); // 利用回数再取得

      store.dispatch("loadingIcon/hideGenIcon");

      ctx.emit("set-stateless", false); // ドロワーを操作可能にする
    };

    const copyToClipboard = () => {
      if (state.genaiResponse) {
        navigator.clipboard.writeText(state.genaiResponse);
        copied.value = true;
        setTimeout(() => {
          copied.value = false;
        }, 3000);

        if (props.mode === "drawer") {
          console.log("props.mode drawer detected");
          ctx.emit("update:drawer", false);
        }
      }
    };

    const getGenaiCount = async () => {
      const params = {};
      params["shop_id"] = store.getters["shops/currentShop"].id;
      const response = await retryRequest(
        ShopGenaiCountRepository.get_all_count,
        params
      );
      if (response.data) {
        state.month_generate_count = response.data.month;
      }
    };

    onMounted(() => {
      getGenaiCount();
    });

    // 初期処理
    const init = async () => {
      store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // console.log("データ取得 fetchData props.cast_id:", props.cast_id);

      const params = new URLSearchParams();
      params.append("shop_id", store.getters["shops/currentShop"].id);
      params.append("cast_id", props.cast_id);
      const response = await retryRequest(CastsRepository.get_shopid, params);
      if (response.data) {
        // 取得データをセット
        for (let idx in response.data.prop) {
          if (response.data.prop[idx].key.startsWith(`cast__genai__`)) {
            if (response.data.prop[idx].key === "cast__genai__personality") {
              // 性格
              const personalityValue = response.data.prop[idx].value;
              state.selectedPersonality = personalityValue
                ? personalityValue.startsWith(setting.text_input_label + "||")
                  ? setting.text_input_label
                  : personalityValue
                : "未選択";
              state.textPersonality = personalityValue
                ? personalityValue.startsWith(setting.text_input_label + "||")
                  ? personalityValue.split("||")[1]
                  : ""
                : "";
            } else if (
              response.data.prop[idx].key === "cast__genai__specialty"
            ) {
              // アピールポイント
              const specialtyValue = response.data.prop[idx].value;
              state.selectedSpecialty = specialtyValue
                ? specialtyValue.startsWith(setting.text_input_label + "||")
                  ? setting.text_input_label
                  : specialtyValue
                : "未選択";
              state.textSpecialty = specialtyValue
                ? specialtyValue.startsWith(setting.text_input_label + "||")
                  ? specialtyValue.split("||")[1]
                  : ""
                : "";
            } else if (response.data.prop[idx].key === "cast__genai__hobbies") {
              // 趣味
              const hobbiesValue = response.data.prop[idx].value;
              state.selectedHobbies = hobbiesValue
                ? hobbiesValue.startsWith(setting.text_input_label + "||")
                  ? setting.text_input_label
                  : hobbiesValue
                : "未選択";
              state.textHobbies = hobbiesValue
                ? hobbiesValue.startsWith(setting.text_input_label + "||")
                  ? hobbiesValue.split("||")[1]
                  : ""
                : "";
            } else if (
              response.data.prop[idx].key ===
              `cast__genai__${props.type}_keyword`
            ) {
              // キーワード
              state.keyword = response.data.prop[idx].value;
            }
          }
        }
      }

      store.dispatch("loadingIcon/hideIcon"); // ローディング非表示
    };

    init();

    return {
      props,
      setting,
      selectItem,
      copied,
      ...toRefs(state),
      onGenai,
      copyToClipboard,
    };
  },
});
</script>

<style scoped>
.gen-hint {
  font-size: 0.8em;
  padding: 6px;
  line-height: 1.2;
  color: #666666;
  background-color: #eeeeee;
  border-radius: 8px;
}
.gen-warning {
  font-weight: bold;
  font-size: 0.8em;
  padding: 6px;
  line-height: 1.2;
  color: white;
  background-color: orange;
  border-radius: 4px;
}
.gen-denger {
  font-weight: bold;
  font-size: 0.8em;
  padding: 6px;
  line-height: 1.2;
  color: white;
  background-color: red;
  border-radius: 4px;
}
</style>
